import { Component, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { CommonService } from '../../common-service.service';
import {Router,ActivatedRoute,Params} from "@angular/router";
import {
NgbModal,
ModalDismissReasons,
NgbPanelChangeEvent,
NgbCarouselConfig
} from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { flatMap } from 'rxjs/operators';

import {FormGroup,FormBuilder,Validators,FormControl} from '@angular/forms';
import swal from 'sweetalert2';


declare var $: any;

@Component({
selector: 'app-navigation',
templateUrl: './navigation.component.html'
})
export class NavigationComponent implements AfterViewInit {
@Output() toggleSidebar = new EventEmitter<void>();

public config: PerfectScrollbarConfigInterface = {};

public showSearch = false;
public userData = null;
public changePasswordForm:FormGroup;
public formSubmittedAttempt = false;
public openRightSidebar=false;

    constructor(
    private modalService: NgbModal,
    private commonService: CommonService,
    private router: Router,
    private formBuilder: FormBuilder,) {
        this.userData = JSON.parse(localStorage.getItem(this.commonService.prefix+'userData'));
        console.log(this.userData);
    }


    // This is for Notifications
    notifications: Object[] = [
    {
        btn: 'btn-danger',
        icon: 'ti-link',
        title: 'Luanch Admin',
        subject: 'Just see the my new admin!',
        time: '9:30 AM'
    },{
        btn: 'btn-success',
        icon: 'ti-calendar',
        title: 'Event today',
        subject: 'Just a reminder that you have event',
        time: '9:10 AM'
    },{
        btn: 'btn-info',
        icon: 'ti-settings',
        title: 'Settings',
        subject: 'You can customize this template as you want',
        time: '9:08 AM'
    },{
        btn: 'btn-primary',
        icon: 'ti-user',
        title: 'Pavan kumar',
        subject: 'Just see the my admin!',
        time: '9:00 AM'
    }
    ];

    // This is for Mymessages
    mymessages: Object[] = [
    {
        useravatar: 'assets/images/users/1.jpg',
        status: 'online',
        from: 'Pavan kumar',
        subject: 'Just see the my admin!',
        time: '9:30 AM'
    },{
        useravatar: 'assets/images/users/2.jpg',
        status: 'busy',
        from: 'Sonu Nigam',
        subject: 'I have sung a song! See you at',
        time: '9:10 AM'
    },{
        useravatar: 'assets/images/users/2.jpg',
        status: 'away',
        from: 'Arijit Sinh',
        subject: 'I am a singer!',
        time: '9:08 AM'
    },{
        useravatar: 'assets/images/users/4.jpg',
        status: 'offline',
        from: 'Pavan kumar',
        subject: 'Just see the my admin!',
        time: '9:00 AM'
    }
    ];


    ngOnInit(){
        this.addForm();
    }

    ngAfterViewInit() {}

    logout(){
        localStorage.removeItem(this.commonService.prefix+'userData');
        localStorage.removeItem(this.commonService.prefix+'authentic_token');
        this.router.navigate(['/login']);
    }

    funOpenRightSidebar(){
        this.openRightSidebar = true;
    }



    addForm(){
        this.changePasswordForm = this.formBuilder.group({
            old_password: ['',[Validators.required]],
            new_password: ['',[Validators.required]],
        });   
    }

    resetForm(){
        this.formSubmittedAttempt = false;
        this.openRightSidebar = false;
        this.changePasswordForm.patchValue({
            old_password : '',
            new_password : '',
        })
    }

    onSubmit(){ 
        this.formSubmittedAttempt = true;
        if(this.changePasswordForm.valid){
          this.commonService.sendRequestToNode({method :'post',path:'changepassword',postData:this.changePasswordForm.value}).subscribe(
            data =>{
                var dialogueTitle = "Updated!"
                if(data.status){
                    swal({
                        title: dialogueTitle,
                        text: data.message,
                        type: 'success',
                        confirmButtonClass: "btn btn-success",
                        buttonsStyling: false
                    })
                    this.resetForm(); //after edit form is reset
                }
                else{
                    alert(data.message);
                }
            })
        }      
    } 

}
